import { render, staticRenderFns } from "./ProjectAssessment.vue?vue&type=template&id=5777c5f1"
import script from "./project-assessment.ts?vue&type=script&lang=ts&external"
export * from "./project-assessment.ts?vue&type=script&lang=ts&external"
import style0 from "./project-assessment.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports